import React from 'react';
import PropTypes from 'prop-types';

import ContentfulImage from '../../../../components/ContentfulImage';

import {
  SlideWrapper,
  ImageWrapper,
  ContentWrapper,
  Subtitle,
  AnswersWrapper,
  ListBtn,
  Title,
  QuestionWrapper,
  BackgroundBorder,
  IconWrapper,
  Description,
  SlideProgress,
  DesktopImageWrapper,
} from './Question.style';
import { BG_GRAY, WHITE } from '../../../../styles/variables.style';

const isSelected = (selectedAnswer, answer, isDouble) => {
  if (isDouble) {
    return selectedAnswer.slug === answer.slug;
  }

  if (Array.isArray(selectedAnswer)) {
    return selectedAnswer.findIndex(item => item.slug === answer.slug) !== -1;
  }

  return selectedAnswer.slug === answer.slug;
};

const QuestionContent = ({
  question,
  copy,
  onAnswer,
  selectedAnswer,
  isSlider,
  darker,
  left,
  double,
  multiArrayElementIndex,
  multiArrayIndex,
}) => (
  <QuestionWrapper darker={darker} left={left} double={double}>
    <Title>{question.title}</Title>
    {question.description && <Description>{question.description}</Description>}
    {!isSlider && (
      <Subtitle>{question.multipleAnswer ? copy.more_than_one_can_be_applied : copy.select_only_one}</Subtitle>
    )}
    <AnswersWrapper>
      {question.answers &&
        question.answers.map(answer => (
          <li key={answer.text}>
            <ListBtn
              // クロージャにしておく
              onClick={() => onAnswer(answer, multiArrayIndex, multiArrayElementIndex)}
              style={{ paddingBottom: answer.description && '12px', paddingTop: answer.description && '12px' }}
            >
              {answer.icon && (
                <IconWrapper>
                  <ContentfulImage
                    src={answer.icon}
                    options={{
                      objectFit: 'cover',
                      size: 25,
                      w: '100%',
                    }}
                  />
                </IconWrapper>
              )}
              {answer.text}
            </ListBtn>
            <BackgroundBorder
              style={{ border: isSelected(selectedAnswer, answer, double) ? '5px solid #000' : 'none' }}
            />
          </li>
        ))}
    </AnswersWrapper>
  </QuestionWrapper>
);

const Question = ({
  onAnswer,
  copy,
  question,
  left,
  medium,
  small,
  selectedAnswer,
  i,
  currentSlide,
  totalSlides,
  multiArrayIndex,
}) => {
  let size = 350;
  if (medium) size = 530;
  if (small) size = 700;
  const isDouble = Array.isArray(question);

  return (
    <SlideWrapper>
      <SlideProgress>
        <span>{currentSlide}</span>/{totalSlides}
      </SlideProgress>
      <ImageWrapper
        medium={medium}
        small={small}
        size={size}
        image={isDouble ? question[0].image && question[0].image.file : question.image && question.image.file}
      >
        <DesktopImageWrapper>
          <ContentfulImage
            src={isDouble ? question[0].image : question.image}
            options={{
              size,
              objectFit: 'cover',
              w: '100%',
            }}
          />
        </DesktopImageWrapper>
      </ImageWrapper>
      <ContentWrapper left={left} medium={medium} small={small}>
        {isDouble ? (
          question.map((q, idx) => {
            let darker = WHITE;
            if (left && idx === 1) {
              darker = BG_GRAY.COMMON_1;
            }
            if (!left && idx === 0) {
              darker = BG_GRAY.COMMON_1;
            }

            return (
              <QuestionContent
                question={q}
                copy={copy}
                onAnswer={onAnswer}
                key={q.title}
                selectedAnswer={selectedAnswer[idx]}
                isSlider={i === 5}
                darker={darker}
                left={left}
                double={isDouble}
                multiArrayElementIndex={idx}
                multiArrayIndex={multiArrayIndex}
              />
            );
          })
        ) : (
          <QuestionContent
            question={question}
            copy={copy}
            onAnswer={onAnswer}
            selectedAnswer={selectedAnswer}
            double={isDouble}
            multiArrayElementIndex={0}
            multiArrayIndex={multiArrayIndex}
          />
        )}
      </ContentWrapper>
    </SlideWrapper>
  );
};

QuestionContent.defaultProps = {
  isSlider: false,
  left: false,
  darker: '',
  double: false,
  multiArrayElementIndex: null,
  multiArrayIndex: null,
};

QuestionContent.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape()),
    title: PropTypes.string,
    image: PropTypes.shape({}),
  }).isRequired,
  copy: PropTypes.shape({
    tell_us_about_yourself: PropTypes.string,
    select_only_one: PropTypes.string,
    more_than_one_can_be_applied: PropTypes.string,
  }).isRequired,
  onAnswer: PropTypes.func.isRequired,
  selectedAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape()), PropTypes.shape()])
    .isRequired,
  isSlider: PropTypes.bool,
  darker: PropTypes.string,
  left: PropTypes.bool,
  double: PropTypes.bool,
  multiArrayElementIndex: PropTypes.number,
  multiArrayIndex: PropTypes.number,
};

Question.defaultProps = {
  copy: {
    tell_us_about_yourself: 'Tell Us About Yourself',
    select_only_one: 'Select only one',
    more_than_one_can_be_applied: 'More than one can be applied',
  },
  left: false,
  medium: false,
  small: false,
  i: -1,
  multiArrayIndex: null,
};

Question.propTypes = {
  onAnswer: PropTypes.func.isRequired,
  question: PropTypes.oneOfType([
    PropTypes.shape({
      answers: PropTypes.arrayOf(PropTypes.shape()),
      title: PropTypes.string,
      image: PropTypes.shape({}),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.shape()),
        title: PropTypes.string,
        image: PropTypes.shape({}),
      })
    ),
  ]).isRequired,
  copy: PropTypes.shape({
    tell_us_about_yourself: PropTypes.string,
    select_only_one: PropTypes.string,
    more_than_one_can_be_applied: PropTypes.string,
  }),
  left: PropTypes.bool,
  medium: PropTypes.bool,
  small: PropTypes.bool,
  selectedAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape()), PropTypes.shape()])
    .isRequired,
  i: PropTypes.number,
  currentSlide: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  multiArrayIndex: PropTypes.number,
};

export default Question;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisHomePage/Slides/Question.js